import { useEffect } from "react";

/**
 * Best-effort image protection (right-click, drag, save-as).
 *
 * Honest caveats:
 *  - This deters casual saves, NOT determined screenshots / DevTools.
 *  - Browsers / OS always allow screenshots — there is no bulletproof prevention.
 *
 * What it does:
 *  - Blocks contextmenu on images.
 *  - Blocks drag on images.
 *  - Adds CSS to disable user-drag + selection on images.
 *  - Intercepts Ctrl/Cmd+S and shows a subtle hint.
 */
export const ImageProtection = () => {
  useEffect(() => {
    const onContextMenu = (e) => {
      const tag = e.target?.tagName;
      if (tag === "IMG" || tag === "PICTURE") {
        e.preventDefault();
      }
    };
    const onDragStart = (e) => {
      const tag = e.target?.tagName;
      if (tag === "IMG" || tag === "PICTURE") {
        e.preventDefault();
      }
    };
    const onKeyDown = (e) => {
      // Block Ctrl/Cmd + S (save page)
      if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "S")) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("dragstart", onDragStart);
    document.addEventListener("keydown", onKeyDown);

    // CSS hardening — apply once
    const styleId = "img-protection-style";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        img, picture {
          -webkit-user-drag: none;
          -khtml-user-drag: none;
          -moz-user-drag: none;
          -o-user-drag: none;
          user-drag: none;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
      `;
      document.head.appendChild(style);
    }

    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("dragstart", onDragStart);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return null;
};

export default ImageProtection;
